import Vue from 'vue'
import {
  PageHeader,
  Loading,
  Spinner,
  ToggleBtn,
  ControlPanel,
  FieldInput,
  FieldSelect,
  FieldOptions,
  ToggleButtons,
  BtnSecondary,
  Modal,
  Toolbar,
  FieldSelectAsync,
  Sidebar,
  Splitter,
  addDirectives,
} from 'vue-kit'
import Router from './router/index'
import { price } from '@/filters'
import { setupHttp } from '@/http'
import { captureTokenFromUrl } from '@/auth/auth'

addDirectives(Router)

export default () => {
  // Сначала ловим JWT из ?auth_token= (редирект с SSO) и настраиваем axios —
  // до первых запросов и до роутера.
  captureTokenFromUrl()
  setupHttp()

  Vue.config.productionTip = false
  Vue.component('loading', Loading)
  Vue.component('spinner', Spinner)
  Vue.component('page-header', PageHeader)
  Vue.component('toggle-btn', ToggleBtn)
  Vue.component('control-panel', ControlPanel)
  Vue.component('field-input', FieldInput)
  Vue.component('field-select', FieldSelect)
  Vue.component('field-options', FieldOptions)
  Vue.component('toggle-buttons', ToggleButtons)
  Vue.component('btn-secondary', BtnSecondary)
  Vue.component('modal', Modal)
  Vue.component('toolbar', Toolbar)
  Vue.component('field-select-async', FieldSelectAsync)
  Vue.component('sidebar', Sidebar)
  Vue.component('splitter', Splitter)
  Vue.filter('price', price)
}
